const version = '1.3.2'
export default version



// WEBPACK FOOTER //
// ./src/version.js